// extracted by mini-css-extract-plugin
export default {"imageWrapper":"style_imageWrapper__Rt-bK"};